export default "<p>sign-in works!</p>\r\n"